import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Device } from 'app/models/device.model';
import { ContainerFormComponent } from '../container-form/container-form.component';
export interface DialogData {
    deviceList: Array<Device>;
    changeDevice: Device;
}
@Component({
    selector: 'app-container-device-list',
    templateUrl: './container-device-list.component.html',
    styleUrls: ['./container-device-list.component.scss']
})

export class ContainerDeviceListComponent implements OnInit {


    constructor(
        public dialogRef: MatDialogRef<ContainerFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {

    }

    ngOnInit(): void {

    }
    change(item) {
        this.dialogRef.close(item)
    }
}
